export const DEFAULT_MAX_TEXT_INPUT_LENGTH = 120
export const DEFAULT_MAX_TEXT_AREA_LENGTH = 1000
export const DEFAULT_MAX_PROFILE_DESCRIPTION_LENGTH = 160
export const PASSWORD_MIN_QUERY_LENGTH = 5

export const DATE_ERROR_INVALID_DATE = 'invalidDate'
export const DATE_ERROR_TOO_EARLY = 'tooEarly'
export const DATE_ERROR_TOO_LATE = 'tooLate'
export const DATE_ERROR_TOO_SHORT = 'tooShort'
